(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-benefits"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-benefits')) {
    customElements.define('product-benefits', class ProductBenefits extends HTMLElement {
      static scrollLocks = new Set();

      static lockScroll(dialog) {
        if (this.scrollLocks.size === 0) this.previousOverflow = document.documentElement.style.overflow;
        this.scrollLocks.add(dialog);
        document.documentElement.style.overflow = 'hidden';
      }

      static unlockScroll(dialog) {
        if (!this.scrollLocks.delete(dialog)) return;
        if (this.scrollLocks.size === 0) document.documentElement.style.overflow = this.previousOverflow || '';
      }

      connectedCallback() {
        if (!window.HTMLDialogElement || typeof HTMLDialogElement.prototype.showModal !== 'function') return;
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const mobileQuery = window.matchMedia('(max-width: 767px)');
        mobileQuery.addEventListener('change', (event) => {
          if (event.matches && this.activeDialog) this.activeDialog.close();
        }, options);
        this.querySelectorAll('.db-benefits__item').forEach((details) => {
          const summary = details.querySelector('summary');
          const dialog = details.querySelector('dialog');
          dialog.removeAttribute('open');
          summary.setAttribute('aria-haspopup', 'dialog');
          details.addEventListener('toggle', () => {
            if (details.open && !dialog.open) {
              document.querySelectorAll('product-benefits').forEach((component) => {
                if (component.activeDialog && component.activeDialog !== dialog) component.activeDialog.close();
              });
              this.activeDialog = dialog;
              dialog.showModal();
              this.constructor.lockScroll(dialog);
            } else if (!details.open && dialog.open) {
              dialog.close();
            }
          }, options);
          dialog.addEventListener('close', () => {
            details.open = false;
            this.constructor.unlockScroll(dialog);
            if (this.activeDialog === dialog) {
              this.activeDialog = null;
            }
            if (summary.isConnected) summary.focus({ preventScroll: true });
          }, options);
          dialog.querySelector('.db-benefits__close').addEventListener('click', () => dialog.close(), options);
          dialog.addEventListener('keydown', (event) => {
            if (event.key !== 'Tab') return;
            const controls = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]'))
              .filter((element) => element.tabIndex >= 0 && element.getClientRects().length > 0);
            const first = controls[0];
            const last = controls[controls.length - 1];
            if (!first) return;
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }, options);
          dialog.addEventListener('click', (event) => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }, options);
        });
        this.setAttribute('data-enhanced', '');
      }

      disconnectedCallback() {
        this.querySelectorAll('dialog').forEach((dialog) => {
          if (dialog.open) dialog.close();
          this.constructor.unlockScroll(dialog);
        });
        this.activeDialog = null;
        this.controller?.abort();
        this.removeAttribute('data-enhanced');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-information_zodiac"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-zodiac-engraving]').forEach((module) => {
    if (module.dataset.initialized) return;
    module.dataset.initialized = 'true';

    const toggle = module.querySelector('input[type="checkbox"]');
    const fields = module.querySelector('.zodiac-engraving__fields');
    const engravingText = module.querySelector('[id^="ZodiacEngravingText-"]');
    const fontSelect = module.querySelector('[data-zodiac-engraving-font]');
    const fontMenu = module.querySelector('[data-zodiac-font-menu]');
    const fontLabel = module.querySelector('[data-zodiac-font-label]');
    const fontOptions = module.querySelectorAll('[data-zodiac-font-option]');
    const fontSizeInput = module.querySelector('[data-zodiac-engraving-size]');
    const sizeOptions = module.querySelectorAll('[data-zodiac-size-option]');
    const engravingValue = module.querySelector('[data-zodiac-engraving-value]');
    const engravingFontValue = module.querySelector('[data-zodiac-engraving-font-value]');
    const engravingFontSizeValue = module.querySelector('[data-zodiac-engraving-size-value]');
    const groupValue = module.querySelector('[data-zodiac-engraving-group]');
    const slideId = 'Slide-' + module.dataset.sectionId + '-' + module.dataset.mediaId;
    const targetSlide = document.getElementById(slideId);
    if (!toggle || !engravingText || !fontSelect || !fontSizeInput || module.dataset.ready !== 'true' || !targetSlide) return;

    targetSlide.style.position = 'relative';
    const preview = document.createElement('div');
    preview.className = 'zodiac-engraving-preview';
    preview.style.fontSize = module.dataset.previewFontSize + 'px';
    preview.hidden = true;
    targetSlide.append(preview);

    const fontFamilies = {
      bellefair: 'Bellefair, Georgia, serif',
      times_new_roman: 'Times New Roman, Times, serif',
      san_francisco: '-apple-system, BlinkMacSystemFont, Arial, sans-serif',
      allura: 'Allura, cursive',
      alex_brush: 'Alex Brush, cursive'
    };
    const sizeChoices = [22, 33, 45];
    const normalize = (value) => value.replace(/\r\n?/g, '\n').split('\n').slice(0, 3).map((line) => line.replace(/[^A-Za-z0-9&. -]/g, '').slice(0, 18)).join('\n');
    const showBackMedia = () => {
      const thumbnailSlider = targetSlide.closest('product-slider-thumbnails');
      if (thumbnailSlider && typeof thumbnailSlider.selectCell === 'function') {
        thumbnailSlider.selectCell('#' + slideId);
        return;
      }
      targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    const update = () => {
      const enabled = toggle.checked;
      const text = normalize(engravingText.value);
      const fontName = fontSelect.options[fontSelect.selectedIndex].text;
      const requestedFontSize = Number(fontSizeInput.value);
      const fontSize = sizeChoices.reduce((closestSize, size) => Math.abs(size - requestedFontSize) < Math.abs(closestSize - requestedFontSize) ? size : closestSize, sizeChoices[0]);
      const rangeProgress = ((Number(fontSize) - Number(fontSizeInput.min)) / (Number(fontSizeInput.max) - Number(fontSizeInput.min))) * 100;

      engravingText.value = text;
      fontSizeInput.value = fontSize;
      fields.hidden = !enabled;
      fields.classList.toggle('zodiac-engraving__fields--hidden', !enabled);
      fields.setAttribute('aria-hidden', String(!enabled));
      engravingText.disabled = !enabled;
      engravingText.required = enabled;
      fontSelect.disabled = !enabled;
      if (fontMenu) {
        fontMenu.classList.toggle('is-disabled', !enabled);
        if (!enabled) fontMenu.open = false;
      }
      if (fontLabel) {
        fontLabel.textContent = fontName;
        fontLabel.style.fontFamily = fontFamilies[fontSelect.value] || module.dataset.previewFontFamily;
      }
      fontOptions.forEach((option) => {
        const selected = option.dataset.fontValue === fontSelect.value;
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-pressed', String(selected));
        option.disabled = !enabled;
      });
      fontSizeInput.disabled = !enabled;
      sizeOptions.forEach((option) => {
        const selected = Number(option.dataset.fontSize) === Number(fontSize);
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-pressed', String(selected));
        option.disabled = !enabled;
      });
      engravingValue.disabled = !enabled || !text.trim();
      engravingFontValue.disabled = !enabled;
      engravingFontSizeValue.disabled = !enabled;
      groupValue.disabled = !enabled;
      engravingValue.value = text;
      engravingFontValue.value = fontName;
      engravingFontSizeValue.value = fontSize + 'px';
      fontSizeInput.style.setProperty('--zodiac-range-progress', rangeProgress + '%');
      if (enabled && !groupValue.value) {
        groupValue.value = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : 'zodiac-' + Date.now();
      }

      module.dataset.enabled = enabled && !!text.trim() ? 'true' : 'false';
      preview.textContent = text;
      preview.style.fontFamily = fontFamilies[fontSelect.value] || module.dataset.previewFontFamily;
      preview.style.fontSize = fontSize + 'px';
      preview.hidden = !enabled || !text.trim();
      if (enabled && text) showBackMedia();
    };

    toggle.addEventListener('change', update);
    engravingText.addEventListener('input', update);
    fontSelect.addEventListener('change', update);
    fontOptions.forEach((option) => option.addEventListener('click', () => {
      fontSelect.value = option.dataset.fontValue;
      if (fontMenu) fontMenu.open = false;
      update();
    }));
    sizeOptions.forEach((option) => option.addEventListener('click', () => {
      fontSizeInput.value = option.dataset.fontSize;
      update();
    }));
    fontSizeInput.addEventListener('input', update);
    update();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-mobile-refinements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-mobile-refinements')) {
    customElements.define('product-mobile-refinements', class extends HTMLElement {
      connectedCallback() {
        this.mobile = matchMedia('(max-width: 767px)');
        this.onChange = this.updateLayout.bind(this);
        this.mobile.addEventListener('change', this.onChange);
        this.builders = [];
        document.querySelectorAll('#main-content > .necklace-builder-cta-section').forEach((section) => {
          const slot = document.createElement('span');
          slot.hidden = true;
          section.before(slot);
          this.builders.push({ section, slot });
        });
        this.updateLayout();
      }

      updateLayout() {
        const story = document.querySelector('#main-content > .section-product-story-modules');
        this.builders.forEach(({ section, slot }) => {
          if (this.mobile.matches && story) story.after(section);
          else slot.after(section);
        });
      }

      disconnectedCallback() {
        this.mobile?.removeEventListener('change', this.onChange);
        this.builders?.forEach(({ section, slot }) => {
          if (slot.isConnected) slot.replaceWith(section);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["story-fullscreen-media"] && !Shopify.designMode) return;
  try {
    (() => {
    const duration = 1000;
    const easing = 'cubic-bezier(0.45, 0, 0.55, 1)';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const animations = new Map();
    const observedVideos = new Set();
    const visibleVideos = new Set();
    const lazyVideoSelector = '[data-fullscreen-lazy-video]';
    let frame = 0;
    let videoObserver;

    const loadVideo = (video) => {
      if (video.dataset.fullscreenVideoLoaded === 'true') return;

      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      if (video.dataset.poster) video.poster = video.dataset.poster;
      video.muted = true;
      video.load();
      video.dataset.fullscreenVideoLoaded = 'true';
    };

    const pauseVideo = (video) => {
      if (!video.paused) video.pause();
    };

    const playVideo = (video) => {
      if (reducedMotion.matches || document.hidden) return;
      loadVideo(video);
      const playback = video.play();
      if (playback) playback.catch(() => {});
    };

    const syncLazyVideos = () => {
      observedVideos.forEach((video) => {
        if (video.isConnected) return;
        if (videoObserver) videoObserver.unobserve(video);
        observedVideos.delete(video);
        visibleVideos.delete(video);
      });

      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll(lazyVideoSelector).forEach((video) => {
          const rect = video.getBoundingClientRect();
          const isVisible = video.getClientRects().length > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
          if (isVisible) {
            playVideo(video);
          } else {
            pauseVideo(video);
          }
        });
        return;
      }

      if (!videoObserver) {
        videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              visibleVideos.add(video);
              playVideo(video);
            } else {
              visibleVideos.delete(video);
              pauseVideo(video);
            }
          });
        }, { threshold: 0.01 });
      }

      document.querySelectorAll(lazyVideoSelector).forEach((video) => {
        if (observedVideos.has(video)) return;
        observedVideos.add(video);
        videoObserver.observe(video);
      });

      if (reducedMotion.matches) {
        observedVideos.forEach(pauseVideo);
      } else {
        visibleVideos.forEach(playVideo);
      }
    };

    const syncAnimations = () => {
      const activeImages = new Set();

      if (!reducedMotion.matches) {
        document.querySelectorAll('.fullscreen-corner-media--scroll-zoom').forEach((section) => {
          const sectionStyle = getComputedStyle(section);
          const start = Number.parseFloat(sectionStyle.getPropertyValue('--fullscreen-corner-media-scroll-zoom-start')) || 1;
          const end = Number.parseFloat(sectionStyle.getPropertyValue('--fullscreen-corner-media-scroll-zoom-end')) || 1.08;

          section.querySelectorAll('.fullscreen-corner-media__image').forEach((image) => {
            activeImages.add(image);
            const current = animations.get(image);

            if (current && current.start === start && current.end === end) return;
            if (current) current.animation.cancel();

            const animation = image.animate(
              [{ transform: `scale(${start})` }, { transform: `scale(${end})` }],
              { duration, easing, fill: 'both' }
            );

            animation.pause();
            animation.currentTime = 0;
            animations.set(image, { animation, start, end, section });
          });
        });
      }

      animations.forEach((record, image) => {
        if (activeImages.has(image) && image.isConnected) return;
        record.animation.cancel();
        animations.delete(image);
      });
    };

    const update = () => {
      frame = 0;
      syncLazyVideos();
      syncAnimations();

      const header = document.querySelector('#header');
      const headerBottom = header ? Math.max(0, Math.min(window.innerHeight, header.getBoundingClientRect().bottom)) : 0;

      document.querySelectorAll('.fullscreen-corner-media--top-text-follow').forEach((section) => {
        const content = section.querySelector('.fullscreen-corner-media__content--top-left, .fullscreen-corner-media__content--top-right');

        if (!content || reducedMotion.matches) {
          if (content) content.style.setProperty('--fullscreen-corner-media-top-text-offset', '0px');
          return;
        }

        const rect = section.getBoundingClientRect();
        const sectionStyle = getComputedStyle(section);
        const followDistance = Number.parseFloat(sectionStyle.getPropertyValue('--fullscreen-corner-media-top-text-follow-distance')) || 0.35;
        const maxOffset = headerBottom + rect.height * followDistance;
        const offset = Math.min(maxOffset, Math.max(0, headerBottom - rect.top));
        content.style.setProperty('--fullscreen-corner-media-top-text-offset', `${offset}px`);
      });

      if (reducedMotion.matches) return;

      const viewportCenter = window.innerHeight / 2;
      animations.forEach((record) => {
        const rect = record.section.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (viewportCenter - rect.top) / rect.height));
        record.animation.currentTime = progress * duration;
      });
    };

    const scheduleUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('shopify:section:unload', scheduleUpdate);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        observedVideos.forEach(pauseVideo);
      } else {
        visibleVideos.forEach(playVideo);
      }
    });
    reducedMotion.addEventListener('change', scheduleUpdate);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
    } else {
      scheduleUpdate();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["story-image-with-text-ultra"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('image-with-text-ultra')) {
    class ImageWithTextUltra extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-ultra-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-ultra-panel]'));
        this.contentPanels = Array.from(this.querySelectorAll('[data-ultra-content-panel]'));
        this.stage = this.querySelector('[data-ultra-stage]');
        this.activeIndex = Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
        this.isVisible = true;
        this.pointerStart = null;
        this.onClick = this.handleClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onPointerDown = this.handlePointerDown.bind(this);
        this.onPointerUp = this.handlePointerUp.bind(this);
        this.onPointerCancel = () => { this.pointerStart = null; };
        this.onVisibilityChange = this.updatePlayback.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        if (this.stage && this.tabs.length > 1) {
          this.stage.addEventListener('pointerdown', this.onPointerDown, { passive: true });
          this.stage.addEventListener('pointerup', this.onPointerUp, { passive: true });
          this.stage.addEventListener('pointercancel', this.onPointerCancel, { passive: true });
        }
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.isVisible = entries[0]?.isIntersecting ?? true;
            this.updatePlayback();
          }, { threshold: 0.05 });
          this.observer.observe(this);
        }
        this.select(this.activeIndex, false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        if (this.stage) {
          this.stage.removeEventListener('pointerdown', this.onPointerDown);
          this.stage.removeEventListener('pointerup', this.onPointerUp);
          this.stage.removeEventListener('pointercancel', this.onPointerCancel);
        }
        this.observer?.disconnect();
        this.querySelectorAll('video').forEach((video) => video.pause());
        this.initialized = false;
      }

      handleClick(event) {
        const tab = event.target.closest('[data-ultra-tab]');
        if (!tab || !this.contains(tab)) return;
        this.select(Number(tab.dataset.ultraIndex), false);
      }

      handleKeydown(event) {
        const tab = event.target.closest('[data-ultra-tab]');
        if (!tab || !this.contains(tab)) return;
        let nextIndex = null;
        const isRtl = document.documentElement.dir === 'rtl';
        if (event.key === 'ArrowRight') nextIndex = this.activeIndex + (isRtl ? -1 : 1);
        if (event.key === 'ArrowLeft') nextIndex = this.activeIndex + (isRtl ? 1 : -1);
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        this.select(nextIndex, true);
      }

      handlePointerDown(event) {
        if (event.pointerType !== 'touch') return;
        this.pointerStart = { x: event.clientX, y: event.clientY };
      }

      handlePointerUp(event) {
        if (!this.pointerStart || event.pointerType !== 'touch') return;
        const deltaX = event.clientX - this.pointerStart.x;
        const deltaY = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        this.select(this.activeIndex + (deltaX < 0 ? 1 : -1), false);
      }

      handleBlockSelect(event) {
        const panel = event.target.closest('[data-ultra-panel], [data-ultra-content-panel]');
        if (!panel || !this.contains(panel)) return;
        this.select(Number(panel.dataset.ultraIndex), false);
      }

      select(index, focusTab) {
        if (!this.panels.length) {
          this.updatePlayback();
          return;
        }
        const normalizedIndex = (index + this.panels.length) % this.panels.length;
        this.activeIndex = normalizedIndex;
        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === normalizedIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });
        this.panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === normalizedIndex;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', String(!isActive));
          panel.inert = !isActive;
        });
        this.contentPanels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === normalizedIndex;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', String(!isActive));
          panel.hidden = !isActive;
          panel.inert = !isActive;
        });
        if (focusTab) this.tabs[normalizedIndex]?.focus();
        this.updatePlayback();
      }

      updatePlayback() {
        this.panels?.forEach((panel, panelIndex) => {
          panel.querySelectorAll('video').forEach((video) => {
            if (panelIndex === this.activeIndex && this.isVisible && !document.hidden) {
              const playPromise = video.play();
              if (playPromise) playPromise.catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      }
    }

    customElements.define('image-with-text-ultra', ImageWithTextUltra);
  }
  } catch(e) { console.error(e); }
})();

})();
